import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceKPIPage from "@/pages/admin/PerformanceKPIPage";

export const Route = createFileRoute("/_admin/admin/performance-kpi")({
  head: () => pageHead("Admin · Performance Kpi", "AKIVA admin · performance kpi portal.", "/admin/performance-kpi", true),
  component: PerformanceKPIPage,
});
